<template>
  <v-container class="pt-10">

    <!-- category title -->
    <v-row v-if="!category.id">
      <v-col cols="12">
        <v-skeleton-loader
          type="list-item-avatar-three-line"
        ></v-skeleton-loader>
      </v-col>
    </v-row>

    <v-row class="pb-10" v-else>

      <v-col class="px-10" align-self="center">

        <div class="text-center">
          <p class="text-h2 font-weight-bold">
            {{ category.name }}
          </p>

          <div v-html="category.description"></div>

        </div>

      </v-col>

    </v-row>

    <!-- libraries -->
    <v-row v-if="isLoading">
      <!-- category libraries -->
      <v-col :cols="isMobile ? 6 : 3"
             v-for="i in (this.isMobile ? 2 : 4)"
             :key="'loading'+i">
        <v-skeleton-loader
            class="mx-auto"
            max-width="300"
            type="card"
         ></v-skeleton-loader>
      </v-col>
    </v-row>
    
    <div v-else-if="category.hasLibraries">  
      <Grid :items="category.sortedLibraries"
            class="mt-10 pb-10"
            @click="onLibraryClick"/>
    </div>

  </v-container>
</template>

<script>
import API from '@/api'

import { mapGetters, mapMutations } from 'vuex'

import slug from '@/mixins/slug'
import utility from '@/mixins/utility'

import Grid from '@/components/Grids/Simple'

export default {
  
  name: 'Library',

  mixins: [ slug, utility ],

  components:
  {
    Grid
  },

  data: () => ({
    category: {}
  }),

  computed:
  {
    ...mapGetters({
      'isLoading': 'ui/isLoading'
    })
  },

  methods: 
  {
    ...mapMutations({
      setLoading: 'ui/setLoading'
    }),

    onLibraryClick(library)
    {
      let params = { slug:library.slug, library:library }

      this.goTo({ name:'library', params })
    },

    load()
    {
      if( this.$route.params.category )
        this.category = this.$route.params.category

      if( !this.slug )
        return
      
      this.setLoading('linear')

      API.category.one(this.slug, { include:'libraries' })
                 .then(({ data })=>{

                  this.category = this.mapModel(data.data, 'category')

                 })
                 .finally(()=>this.setLoading(false))
    },
  },

  mounted()
  {
    this.load()

    this.setBack('home')
  },

  watch:
  {
    
  }

}
</script>
